import { render, staticRenderFns } from "./datasubject-transfering-prevention-panel.vue?vue&type=template&id=f070a5e8"
import script from "./datasubject-transfering-prevention-panel.vue?vue&type=script&lang=js"
export * from "./datasubject-transfering-prevention-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports